<template>
	<div class="FSelectBox">
		<div class="tit">{{Language.Fresh.tips_input_receiver_phone[isLanguage]}}</div>
		<div class="table">
			<div class="list">
				<div class="item">{{Language.LG.BoxSize[isLanguage]}}</div>
				<!-- <div class="item">{{Language.LG.SmallBox[isLanguage]}}</div>
				<div class="item">{{Language.LG.MedBox[isLanguage]}}</div>
				<div class="item">{{Language.LG.BigBox[isLanguage]}}</div> -->
				<div class="item" v-for="(item,index) in boxList" :key="index">{{item.name}}</div>
			</div>
			<div class="list">
				<div class="item">{{Language.LG.BoxNum[isLanguage]}}</div>
				<div class="item" v-for="(num,index) in boxList" :key="index">{{num.BoxNum}}</div>
			</div>
		</div>
		<div class="RadioBox">
			<label class="label">{{Language.Fresh.receiver_phone_no[isLanguage]}}</label>
			<el-input v-model="phone_no" type="Number"></el-input>
		</div>

		<div class="RadioBox">
			<label class="label">{{Language.LG.SelectBox[isLanguage]}}</label>
			<el-radio-group v-model="boxSize">
				<el-radio v-for="(num,index) in boxList" :key="index" :label="num.BoxSize" :disabled="num.disabled">{{num.name}}</el-radio>
			</el-radio-group>
		</div>
		<div class="SelBtn">
			<button class="subBtn" @click="ToScan()">{{Language.LG.Confirm[isLanguage]}}</button>
		</div>
		
		<!--超时组件-->
		<overTime :callBack="backUp"></overTime>
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>
		<!--loading -->
		<ELoading v-if="isLoading" :LoadingType="'2'"></ELoading>
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import ELoading from '../assets/Loading.vue'
	import { EloginApi } from '../../../../static/FreshCabinet/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	import * as config from '../../../../static/js/config.js';
	var vm
	export default {
		name:'FSelectBox',
		data() {
			return {
				configStorage:null,
				
				isLanguage:0,
				Language:'',
				
				phone_no:'',//收件人手机号

				boxSize:'',//当前选中
				//箱格各自数量
				boxList:[],
				
				isLoading:false,
			};
		},
		async created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			
			this.$store.state.overTime = 80
			
			this.BoxAmountInfo()
		},
		components:{
			overTime,
			EConfigBtn,
			ELoading
		},
		methods:{
			//获取设备剩余箱柜信息
			async BoxAmountInfo(){
				let token = storage.localGetItem('courierToken')
				let data = {
					'DeviceId': config.deviceId
				}
				const res = await EloginApi.BoxAmountInfo(data,token)
				console.log(res)
				if(res){
					if(res.ErrCode==0){
						var arr = res.Result.BoxList
						for(var i in arr){
							arr[i].disabled = false
							//判断数量是否为0，如是，单选框不能选择
							if(arr[i].BoxNum==0){
								arr[i].disabled = true
							}
							//判断箱格的类型，显示不同的文字，A极大，B大箱，C中箱，D小箱，E极小
							if(arr[i].BoxSize == 'A'){
								arr[i].name = vm.$Language.LG.ExtBoxRd[vm.isLanguage]
							}else if(arr[i].BoxSize == 'B'){
								arr[i].name = vm.$Language.LG.BigBoxRd[vm.isLanguage]
							}else if(arr[i].BoxSize == 'C'){
								arr[i].name = vm.$Language.LG.MedBoxRd[vm.isLanguage]
							}else if(arr[i].BoxSize == 'D'){
								arr[i].name = vm.$Language.LG.SmallBoxRd[vm.isLanguage]
							}else if(arr[i].BoxSize == 'E'){
								arr[i].name = vm.$Language.LG.MiniBoxRd[vm.isLanguage]
							}
						}
						vm.boxList = arr
					}else{
						vm.$message({
							message: res.ErrMsg,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//选择好箱格,去扫码
			ToScan(){
				if(vm.boxSize == ''){
					vm.$message({
						message: '请选择箱格大小',
						type: 'error',
						duration:1000
					});
					return
				}
				let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
				if (vm.phone_no === '') {
					vm.$message({
						message: '请输入手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(!rePhone.test(vm.phone_no)){
					vm.$message({
						message: '请输入正确手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}
				this.isLoading = true
				setTimeout(function(){
					vm.$router.push({
						path:'/FreshCabinet/FScanCode',
						query:{
							'type': 1,
							'boxSize':vm.boxSize,
							'phone_no':vm.phone_no
						}
					})
				},2000)
			},
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/FreshCabinet/FDeliveryType'
				})
			},
			//退出登录
			quit(){
				storage.localRemoveItem('courierToken')
				storage.localRemoveItem('userInfo')
				vm.$router.push({
					path:'/FreshCabinet'
				})
			}
		},
	}
</script>

<style lang="less">
.FSelectBox{
	position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
	background: #f2f2f2;
	color: #151c36;
	text-align: center;
	.SelBtn{
		.subBtn{
			display: inline-block;
			line-height: 1 !important;
			padding: 0.3rem 0.5rem;
			border-radius: 0.15rem;
			background: #151c36;
			font-size: 0.3rem;
			color: #fff;
		}
	}
	.RadioBox{
		width: 50%;
		margin: 0 auto 0.3rem;
		display: flex;
		align-items: center;
		.el-input__inner{
			height: 0.8rem;
			line-height: 0.8rem;
			font-size: 0.36rem;
		}
		.el-radio-group{
			margin-left: 0.2rem;
		}
		.el-radio{
			font-size:0.36rem;
			.el-radio__label{
				font-size: 0.36rem;
				padding-left: 0.1rem;
				color: #666;
			}
			.el-radio__inner{
				width: 0.36rem;
				height: 0.36rem;
				border: 0.02rem solid #999;
				&:after{
					content: "";
					width: 0.1rem;
					height: 0.1rem;
				}
			}
		}
		// .el-radio{
		// 	font-size: 0.36rem;
		// 	margin-right: 0.2rem;
		// }
		.label{
			background: #151c36;
			color: #fff;
			width: 2.5rem;
			height: 0.8rem;
			line-height: 0.8rem;
			border-top-left-radius: 0.15rem;
			border-bottom-left-radius: 0.15rem;
			flex-shrink: 0;
			font-size: 0.26rem;
		}
	}
	.table{
		background: #fff;
		color: #151c36;
		font-size: 0.4rem;
		box-shadow: 0 0.02rem 0.03rem 0 rgba(0,0,0,.5);
		width: 50%;
		margin: 0 auto 0.2rem;
		border-radius: 0.1rem;
		position: relative;
		.confirmBtn{
			background:url('../../../../static/FreshCabinet/images/btn_blue_circle_normal.png') no-repeat;
			background-size: cover;
			width: 2.5rem;
			height: 2.5rem;
			color: #151c36;
			position: absolute;
			left: 110%;
			top:50%;
			margin-top: -1.25rem;
			border-radius: 50%;
			z-index: 10;
			.cFlex{
				width: 100%;
				height: 2.5rem;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 0.3rem;
				padding: 0 0.15rem;
				box-sizing: border-box;
			}
			&:active{
				background:url('../../../../static/FreshCabinet/images/btn_blue_circle_focus.png') no-repeat;
				background-size: cover;
			}
			.time{
				position: absolute;
				width: 100%;
				bottom: 0.4rem;
				left: 0;
				line-height: 1;
			}
		}
		.list{
			display: flex;
			align-items: center;
			border-bottom: 0.02rem solid #ddd;
			padding: 0.2rem 0;
			&:last-child{
				border-bottom: none;
			}
			.item{
				flex: 1;
				flex-shrink: 0;
				height: 1rem;
				line-height: 1rem;
				border-right: 0.02rem solid #ddd;
				&:last-child{
					border-right: none;
				}
			}
		}
	}
	.tit{
		padding: 0.8rem 0 0.2rem;
		font-size: 0.45rem;
		color: #151c36;
	}
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/SelectBox/SelectBox.vue